var _path, _path2, _circle, _line, _line2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentsRenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0574 1.75257C6.44279 2.69387 2.33323 3.49741 1.89702 3.58924C0.0373814 3.93362 -0.651372 6.09171 0.726135 7.37739L1.41489 8.02022V10.9819C1.41489 13.3925 1.27714 14.6323 0.726135 17.3643C-0.37587 22.8055 -0.306995 22.9891 2.83831 22.9891C5.89178 22.9891 5.96066 22.8055 4.85865 17.3643C4.33061 14.7241 4.1699 13.3466 4.1699 11.2344C4.1699 9.21406 4.23878 8.52531 4.46836 8.52531C4.60611 8.52531 5.59332 8.68602 6.64941 8.89264L8.532 9.28294V12.4053C8.532 17.2495 9.38147 19.7979 11.7462 22.2774C14.065 24.6881 16.6134 25.7441 20.1031 25.7441C23.4091 25.7212 25.659 24.8028 28.0696 22.3922C30.641 19.8897 31.4904 17.3873 31.4904 12.4053V9.28294L34.6587 8.66306C38.6076 7.88247 39.2045 7.69881 39.6407 7.07893C40.3065 6.11467 40.008 4.43871 39.0667 3.93362C38.5846 3.68108 20.3097 0.00772858 19.7587 0.0536461C19.575 0.0766048 15.6721 0.834232 11.0574 1.75257Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12737 29.7613C7.0152 30.6108 5.72953 31.4832 4.05356 33.1822C2.30872 34.9729 1.25263 36.7178 0.51796 39.1513C-0.0789597 41.0799 -0.147835 43.9726 0.403168 44.7532C1.25263 45.993 0.632752 45.947 20.0556 45.947C37.4581 45.947 38.055 45.9241 38.7667 45.4879C39.8687 44.8221 40.0524 44.294 39.9376 42.0671C39.6391 37.0392 36.6316 32.5852 32.0169 30.2894C30.1114 29.3481 28.9864 29.1415 28.091 29.6236C27.8844 29.7384 26.1625 31.4832 24.2799 33.5036C22.3744 35.5469 20.6525 37.2458 20.4229 37.2917C20.1933 37.3606 19.826 37.3606 19.5735 37.2917C19.3439 37.2458 17.6679 35.5928 15.8772 33.6413C14.0634 31.6899 12.3645 29.968 12.112 29.8073C11.2625 29.2563 10.413 29.2333 9.12737 29.7613Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 30.0527,
    r: 14,
    fill: "white",
    fillOpacity: 0.8,
    stroke: "currentColor",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.5,
    y1: 31.0527,
    x2: 23.5,
    y2: 18.0527,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.3123,
    y1: 30.6623,
    x2: 31.121,
    y2: 36.9093,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 30.5527,
    r: 1.5,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsRenew);
export default __webpack_public_path__ + "static/media/students-renew.2302e96828cb436b09bd8094b59a416d.svg";
export { ForwardRef as ReactComponent };